import {reducer} from './helpers'
import {
  GET_FIT_PROFILE_FAILURE,
  GET_FIT_PROFILE_PENDING,
  GET_FIT_PROFILE_SUCCESS,
  SET_FIT_PROFILE_FAILURE,
  SET_FIT_PROFILE_PENDING,
  SET_FIT_PROFILE_SUCCESS,
} from '../actions/fitProfile'
import FitProfile, {EMPTY_FIT_PROFILE} from '../types/FitProfile'

const initialState = {
  data: null,
  error: null,
  status: null,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case GET_FIT_PROFILE_PENDING:
    case SET_FIT_PROFILE_PENDING:
      return {
        status: 'PENDING',
      }
    case GET_FIT_PROFILE_FAILURE:
    case SET_FIT_PROFILE_FAILURE:
      return {
        data: null,
        error: action.payload,
        status: 'FAILURE',
      }
    case GET_FIT_PROFILE_SUCCESS:
    case SET_FIT_PROFILE_SUCCESS:
      return {
        data: action.payload ? new FitProfile(action.payload) : EMPTY_FIT_PROFILE,
        error: null,
        status: 'SUCCESS',
      }
    default:
      return null
  }
})
